<template>
	<v-col cols="12">
		<v-card v-if="render">
		<v-card-text>
			<p class="display-1 text--primary">
			{{ cardTitle }}
			</p>
			<div class="text--primary">
			{{ description }}
			</div>
		</v-card-text>
		<v-card-actions>
			<v-btn text color="cyan accent-4" :to="{ name: reportLink }"
			>{{txt.goToTheReport}}
			</v-btn>
		</v-card-actions>
		</v-card>
	</v-col>
</template>

<script>
export default {
	name: 'HomeCard',
	props: {
		render: {
			type: Boolean,
			default: true,
		},
		cardTitle: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		reportLink: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			txt: {
				goToTheReport: 'Go to the report',
			},
		}
	},
}
</script>

<style>

</style>
